import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/apiClient";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [isOrder, setIsOrder] = useState(false);
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    setIsOrder(params.get("type") === "order");
    if (params.get("type") === "order") localStorage.removeItem("drive_cart");
    if (!sessionId) { setStatus("error"); return; }

    const poll = async () => {
      if (attempts.current >= 8) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* retry */ }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  const config = {
    checking: { icon: <Loader2 className="w-14 h-14 text-olive animate-spin" />, title: "Vérification du paiement...", desc: "Merci de patienter quelques instants." },
    paid: isOrder
      ? { icon: <CheckCircle2 className="w-14 h-14 text-olive" />, title: "Commande confirmée !", desc: "Votre paiement a bien été reçu. Vos courses seront déposées dans votre logement." }
      : { icon: <CheckCircle2 className="w-14 h-14 text-olive" />, title: "Réservation confirmée !", desc: "Votre paiement a bien été reçu. Retrouvez votre séjour dans votre espace." },
    timeout: { icon: <Loader2 className="w-14 h-14 text-rose-brand" />, title: "Paiement en cours de traitement", desc: "Votre paiement est en cours de confirmation. Vérifiez vos séjours dans quelques instants." },
    error: { icon: <XCircle className="w-14 h-14 text-destructive" />, title: "Un problème est survenu", desc: "Le paiement n'a pas pu être confirmé." },
  }[status] || {};

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-lg mx-auto px-5 py-24 text-center fade-up" data-testid="payment-success-page">
        <div className="flex justify-center mb-6">{config.icon}</div>
        <h1 className="font-serif text-3xl text-olive">{config.title}</h1>
        <p className="text-muted-foreground mt-2">{config.desc}</p>
        <Button onClick={() => navigate(isOrder ? "/courses" : "/mes-sejours")} className="mt-8 bg-rose-brand hover:bg-rosebrand-soft text-white rounded-full px-8" data-testid="go-to-trips-button">
          {isOrder ? "Voir mes commandes" : "Voir mes séjours"}
        </Button>
      </div>
    </div>
  );
}
